import React from 'react';
import {Dialog} from 'primereact/dialog';

import styles from './auth.module.css';
import {PasswordResetForm} from '../../domains/passwordResetForm';
import {useAuth} from './auth-provider';

export const PasswordResetDialog = () => {
  const {
    passwordResetVisible,
    closePasswordResetModal,
  } = useAuth();

  return (
    <Dialog
      header="Восстановление пароля"
      visible={passwordResetVisible}
      style={{width: '50vw'}}
      onHide={() => {
        if (!passwordResetVisible) return;
        closePasswordResetModal();
      }}
      pt={{
        header: {
          className: styles.cardWrapper,
        },
        content: {
          className: styles.cardWrapper,
        },
        footer: {
          className: styles.cardWrapper,
        },
      }}
    >
      <PasswordResetForm />
    </Dialog>
  );
}
